exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-homepage-template-js": () => import("./../../../src/templates/HomepageTemplate.js" /* webpackChunkName: "component---src-templates-homepage-template-js" */),
  "component---src-templates-page-template-js": () => import("./../../../src/templates/PageTemplate.js" /* webpackChunkName: "component---src-templates-page-template-js" */),
  "component---src-templates-single-post-template-js": () => import("./../../../src/templates/SinglePostTemplate.js" /* webpackChunkName: "component---src-templates-single-post-template-js" */)
}

